import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useIsAutoPopulationDone } from './useIsAutoPopulationDone';
import { hasEnoughTimeElapsedSinceDate } from '@shared/utils/dateHelpers';
import { useEventInfo } from '@shared/utils/eventInfo';

interface UseAutoPopulationFeatureFlagsReturn
  extends Readonly<{
    hasEnoughTimeElapsed: boolean;
    isAutoPopulationDoneFromStorage: boolean;
    isLoadingFeatureFlags: boolean;
  }> {}

/**
 * Extracts and consolidates all feature flag logic for auto-population.
 */
export const useAutoPopulationFeatureFlags = (validateIsEnoughTimeElapsed?: boolean): UseAutoPopulationFeatureFlagsReturn => {
  const [, loadingDialog, , dialogPayload] = useIsFeatureEnabled('showAutoPopulationCompletedDialog');
  const { eventInfo, loading: eventInfoLoading } = useEventInfo();

  const durationHours = (dialogPayload as { durationHours?: number })?.durationHours ?? 0;
  const hasEnoughTimeElapsed = hasEnoughTimeElapsedSinceDate(durationHours, new Date(eventInfo?.firebaseCreateAt?.timestamp));

  const { isAutoPopulationDone: isAutoPopulationDoneFromStorage, isLoadingAutoPopulationFlag } = useIsAutoPopulationDone();

  const isLoadingFeatureFlags = loadingDialog || eventInfoLoading || isLoadingAutoPopulationFlag;
  return {
    hasEnoughTimeElapsed: validateIsEnoughTimeElapsed ? hasEnoughTimeElapsed : true,
    isAutoPopulationDoneFromStorage,
    isLoadingFeatureFlags,
  };
};
